import React, { useEffect, useState } from 'react';
import API_BASE from '../config';
import { useLanguage } from '../contexts/LanguageContext';
import { useToast } from '../contexts/ToastContext';
import ContactLanding from './home/ContactLanding';
import { useContactLanding } from './home/useContactLanding';
import { getContactCopy } from './home/contactCopy';
import { openTawkChat, useTawkTo } from './home/useTawkTo';

const Contact: React.FC = () => {
  const { language, setLanguage } = useLanguage();
  const toast = useToast();
  const lang = language === 'en' ? 'en' : 'cs';
  const v = useContactLanding(lang);
  const [submitting, setSubmitting] = useState(false);
  const c = getContactCopy(lang);
  useTawkTo();

  useEffect(() => {
    document.documentElement.style.scrollBehavior = 'smooth';
    return () => {
      document.documentElement.style.scrollBehavior = '';
    };
  }, []);

  const onContactSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (submitting) return;
    const form = e.currentTarget;
    const fd = new FormData(form);
    const payload = {
      firstName: String(fd.get('firstName') || '').trim(),
      lastName: String(fd.get('lastName') || '').trim(),
      email: String(fd.get('email') || '').trim(),
      companyName: String(fd.get('company') || '').trim(),
      companySize: '',
      subject: String(fd.get('subject') || '').trim(),
      message: String(fd.get('message') || '').trim(),
      newsletter: false,
    };
    if (!payload.firstName || !payload.lastName || !payload.email || !payload.subject || !payload.message) {
      toast.error(c.requiredError);
      return;
    }
    setSubmitting(true);
    try {
      const res = await fetch(`${API_BASE}/api/contact/submit`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      const data = await res.json();
      if (!res.ok || !data.success) {
        throw new Error(data.message || c.sendFailed);
      }
      toast.success(c.sendSuccess);
      form.reset();
    } catch (err: unknown) {
      const message = err instanceof Error ? err.message : c.sendFailed;
      toast.error(message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <ContactLanding
      v={v}
      lang={lang}
      onSetCz={() => setLanguage('cs')}
      onSetEn={() => setLanguage('en')}
      onContactSubmit={onContactSubmit}
      onOpenLiveChat={openTawkChat}
      submitting={submitting}
    />
  );
};

export default Contact;
